/**
 * 微信分享，qq分享
 * @param shareOptions {Object} - 分享参数
 * @param options.title {String} - 分享标题
 * @param options.desc {String} - 分享简介
 * @param options.link {String} - 分享跳转链接
 * @param options.imgUrl {String} - 分享图片
 * @param options.success {Function} - 用户确认分享后执行的回调函数, 用于埋点
 */

import axios from 'axios';

import getSystemInfo from '@/utils/getSystemInfo';

const WX_SHARE_API = 'https://wapapi.nfnews.com/nfplus-wap-api/wx/getShareSignInfo';

// 是否已经初始化过微信分享，如果初始化了，则无需再请求签名
let isInitWxShare = false;

// 获取公众号信息
const getWxPublic = () => {
  let shareUrl = window.location.href.split('#')[0];
  let sendData = {
    shareUrl: encodeURIComponent(shareUrl)
  };
  const url = `${WX_SHARE_API}?shareUrl=${sendData.shareUrl}`;
  return axios.get(url);
};

const setShareInfo = (shareOptions) => {
  //分享到朋友圈
  window.wx.onMenuShareTimeline(Object.assign({}, shareOptions, { shareChanel: '2' }));
  //分享给朋友
  window.wx.onMenuShareAppMessage(Object.assign({}, shareOptions, { shareChanel: '1' }));
  //分享到QQ
  window.wx.onMenuShareQQ(Object.assign({}, shareOptions, { shareChanel: '4' }));
};

const wxShare = (publicInfo, shareOptions) => {
  window.wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: publicInfo.app_id, // 必填，公众号的唯一标识
    timestamp: publicInfo.timestamp, // 必填，生成签名的时间戳
    nonceStr: publicInfo.nonceStr, // 必填，生成签名的随机串
    signature: publicInfo.signature, // 必填，签名，见附录1
    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'previewImage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
  });
  window.wx.ready(function () {
    setShareInfo(shareOptions);
    isInitWxShare = true;
  });
};

// 设置head的参数，用于qq分享
const setShareHead = (shareOptions) => {
  function addMeta(name, content) {
    //手动添加mate标签
    let meta = document.createElement('meta');
    meta.content = content;
    meta.setAttribute('itemprop', name);
    document.getElementsByTagName('head')[0].appendChild(meta);
  }
  addMeta('name', shareOptions.title);
  addMeta('description', shareOptions.desc);
  addMeta('image', shareOptions.imgUrl);
};

const initWxShare = async (shareOptions) => {
  if (!isInitWxShare) {
    let getWxPublic_result = await getWxPublic();
    if (!getWxPublic_result.data) return;
    wxShare(getWxPublic_result.data.data, shareOptions);
  } else {
    setShareInfo(shareOptions);
  }
  setShareHead(shareOptions);
  const systemInfo = await getSystemInfo();
  // app端内环境
  // console.log('systemInfo', systemInfo)
  if (systemInfo.isNfPlus) {
    const options = {
      shareDesc: shareOptions.desc,
      shareTitle: shareOptions.title,
      shareIcon: shareOptions.icon,
      shareUrl: window.location.href
    };

    window.nfplusJsbridge.setShareInfo(options);

    if (window.nfplusJsbridge?.updateAppMessageShareData) {
      window.nfplusJsbridge.updateAppMessageShareData({
        title: options.shareTitle,
        desc: options.shareDesc,
        imgUrl: options.shareIcon,
        link: options.shareUrl
      });
    }
  }
};

export default initWxShare;
